import { Location } from '@angular/common';
import { Router } from '@angular/router';

/**
 * Navigate to the previous history entry when available; otherwise ``router.navigate(fallback)``.
 */
export function goBackOrNavigate(
  location: Location,
  router: Router,
  fallback: (string | number | boolean)[],
): void {
  if (typeof window !== 'undefined' && window.history.length > 1) {
    location.back();
  } else {
    void router.navigate(fallback);
  }
}
